import { clusterFor } from '../operations/server-target'

// Which Flowrunner a command is talking to, in the words someone would use out loud.
//
// The URL alone is not the thing people check for — "am I about to deploy to prod" is answered by a name.
// A server that is not one of ours has no name to give, so the URL stands on its own.

const CLUSTER_LABELS: Record<string, string> = {
  prod : 'Prod',
  dev  : 'Dev',
  local: 'Local',
}

export function describeServer(serverUrl: string): string {
  const cluster = clusterFor(serverUrl)

  return cluster
    ? `Flowrunner ${ CLUSTER_LABELS[cluster] } cluster (${ serverUrl })`
    : serverUrl
}
